<template>
    <div>
        <component @click.stop :is="linkComponent" v-bind="linkProps" :class="{'btn-default': !hidden_status && price_check.enable}" :style="{color: price_check.text_color, backgroundColor: price_check.color}">
            {{ displayText }}
        </component>
    </div>
</template>
<script>
    import utils from "~/mixins/utils";

    export default {
        mixins: [utils],
        props: {
            hidden_status: {
                type: String,
                default: '',
            },
            price_check: {
                type: Object,
                default: {
                    enable: false,
                    text: '',
                    color: '',
                    text_color: '',
                    link: '',
                    target: '_blank',
                }
            },
        },


        data() {
            return {
                defaultMessages: {
                    not_authenticated: 'Faça login para consultar o preço e adquirir o produto.',
                    not_permission: 'Você ainda não tem permissão para visualizar o preço.'
                }
            };
        },

        computed: {
            displayText() {
                if (this.hidden_status) {
                    return this.hidden_status === 'not_permission' && this.isAuthenticated
                        ? this.messages.not_permission
                        : this.messages.not_authenticated;
                }
                return this.price_check.text || 'Consulte o preço no nosso Whatsapp';
            },

            linkComponent() {
                if (this.hidden_status) {
                    return this.isAuthenticated ? 'span' : 'nuxt-link';
                }
                return this.price_check.enable ? 'a' : 'span';
            },

            linkProps() {
                if (this.hidden_status) {
                    return this.isAuthenticated ? {} : { to: `/login?next=${this.$route.path}` };
                }
                return this.price_check.enable ? { rel:"noopener noreferrer", target: this.price_check.target, href: this.price_check.link } : {};
            },

            messages() {
                const customMessages = {};

                if ('b2b' in this.$wdconfig.modules) {
                    const { b2b } = this.$wdconfig.modules;
                    if (b2b.not_authenticated_price_message) {
                        customMessages.not_authenticated = b2b.not_authenticated_price_message;
                    }
                    if (b2b.not_permission_price_message) {
                        customMessages.not_permission = b2b.not_permission_price_message;
                    }
                }

                return {
                    not_authenticated: this.message_not_authenticated || customMessages.not_authenticated || this.defaultMessages.not_authenticated,
                    not_permission: this.message_not_permission || customMessages.not_permission || this.defaultMessages.not_permission
                };
            },

            isAuthenticated() {
                return this.$store.getters.isAuth;
            }
        }
    };
</script>
